"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[4145],{

/***/ 54145:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(69396);
/* harmony import */ var _pancakeswap_tokens__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(94200);



var farms = [
    /**
   * These 3 farms (PID 0, 2, 3) should always be at the top of the file.
   */ {
        pid: 0,
        v1pid: 0,
        lpSymbol: "RBL",
        lpAddress: "0x66e48f356C34bF38f5e8bB9b77FB42F5705F5639",
        token: _pancakeswap_tokens__WEBPACK_IMPORTED_MODULE_0__/* .bscTokens.irs */ .ds.irs,
        quoteToken: _pancakeswap_tokens__WEBPACK_IMPORTED_MODULE_0__/* .bscTokens.wbnb */ .ds.wbnb
    },
    {
        pid: 1,
        v1pid: 1,
        lpSymbol: "RBL-BNB LP",
        lpAddress: "0x556899f43015cee14b2197496211d8e62f704f8b",
        token: _pancakeswap_tokens__WEBPACK_IMPORTED_MODULE_0__/* .bscTokens.irs */ .ds.irs,
        quoteToken: _pancakeswap_tokens__WEBPACK_IMPORTED_MODULE_0__/* .bscTokens.wbnb */ .ds.wbnb,
        boosted: true
    },
    {
        pid: 2,
        v1pid: 2,
        lpSymbol: "RBL-BUSD LP",
        lpAddress: "0x4ef52af6c127960e4ffe568d89205414d4f46f3b",
        boosted: true,
        token: _pancakeswap_tokens__WEBPACK_IMPORTED_MODULE_0__/* .bscTokens.irs */ .ds.irs,
        quoteToken: _pancakeswap_tokens__WEBPACK_IMPORTED_MODULE_0__/* .bscTokens.busd */ .ds.busd
    },
    {
        pid: 3,
        v1pid: 3,
        lpSymbol: "BUSD-BNB LP",
        lpAddress: "0x58F876857a02D6762E0101bb5C46A8c1ED44Dc16",
        token: _pancakeswap_tokens__WEBPACK_IMPORTED_MODULE_0__/* .bscTokens.busd */ .ds.busd,
        quoteToken: _pancakeswap_tokens__WEBPACK_IMPORTED_MODULE_0__/* .bscTokens.wbnb */ .ds.wbnb
    }, 
].map(function(p) {
    return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({}, p), {
        token: p.token.serialize,
        quoteToken: p.quoteToken.serialize
    });
});
/* harmony default export */ __webpack_exports__["default"] = (farms);


/***/ })

}]);